import styled from "styled-components";

export const ContainerOuter = styled.div`
    min-height: 100vh;
    background-size: 100%;
    background-position: center;
    background-image: url('/Assets/background_2.jpg');
    @media (min-width: 1000px) {
        background-size: 25%;
    }
`;

export const LoaderContainer = styled.div`
    min-height: 90vh;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const ContainerDiv = styled.div`
    margin-top: 65px;
`;

export const ContainerInner = styled.div`
    width: 500px;
    margin: 0 auto;
    padding: 40px 0;
    border-radius: 5px;
    @media (max-width: 600px){
        width: 94%;
        margin: 0 15px;
    }
`;

export const Title = styled.h4`
    text-align: center;
`;